var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-tabbed-view"},[_c('div',{key:_vm.prefixID + _vm.a,staticClass:"u-tabbed-view-tabs"},_vm._l((_vm.tabs),function(c){return _c('a',{key:c.name || c.header,class:{
                'u-tabbed-view-tab': true,
                'u-tabbed-view-tab--active': c.active
            },on:{"click":function($event){return _vm.setActive(c)}}},[_vm._v(_vm._s(c.header))])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7423f5a6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/TabbedView.vue
// module id = U+ER
// module chunks = 1